import React, { useState } from 'react';
import { Card, Nav, Tab } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import UsersManagement from './admin/AdmUsersManagement';
import CommunitiesManagement from './admin/AdmCommunitiesManagement';
import UnverifiedUsers from './admin/AdmUnverifiedUsers';
import InvitationManagement from './admin/AdmInvitationManagement';
import CommunityUsersAssociations from './admin/CommunityUsersAssociations';

function GlobalAdminDashboard() {
    const [activeKey, setActiveKey] = useState('users');
    const { user } = useAuth();

    // Make sure only global admins can access this page
    if (!user || user.role !== 'global_admin') {
        return (
            <div className="alert alert-danger">
                <h4>Unauthorized Access</h4>
                <p>You do not have permission to access this page.</p>
            </div>
        );
    }

    return (
        <div className="global-admin-dashboard">
            <h2 className="mb-4">Global Admin Dashboard</h2>
            
            <Card>
                <Card.Header>
                    <Nav variant="tabs" activeKey={activeKey} onSelect={setActiveKey}>
                        <Nav.Item>
                            <Nav.Link eventKey="users">Users</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="unverified">Unverified Users</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="communities">Communities</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="invitations">Invitations</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="community_users">Community-User Associations</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Card.Header>
                <Card.Body>
                    <Tab.Content>
                        <Tab.Pane active={activeKey === 'users'}>
                            <UsersManagement />
                        </Tab.Pane>
                        <Tab.Pane active={activeKey === 'unverified'}>
                            <UnverifiedUsers />
                        </Tab.Pane>
                        <Tab.Pane active={activeKey === 'communities'}>
                            <CommunitiesManagement />
                        </Tab.Pane>
                        <Tab.Pane active={activeKey === 'invitations'}>
                            <InvitationManagement />
                        </Tab.Pane>
                        <Tab.Pane active={activeKey === 'community_users'}>
                            <CommunityUsersAssociations />
                        </Tab.Pane>
                    </Tab.Content>
                </Card.Body>
            </Card>
        </div>
    );
}

export default GlobalAdminDashboard;